import api from 'api'
import { WorkStatus } from 'api/typings'

type EditShiftWorkRequest = {
  shiftId: number
  workId: number
  status?: WorkStatus
  clockedInAt?: string
  clockedOutAt?: string
  leftEarly?: boolean
  bypassMaxDaysForEditWork?: boolean
}

export const editShiftWork = async (request: EditShiftWorkRequest) => {
  const {
    shiftId,
    workId,
    status,
    clockedInAt,
    clockedOutAt,
    leftEarly,
    bypassMaxDaysForEditWork,
  } = request
  let url = `/admin/shift/${shiftId}/work/${workId}`
  if (bypassMaxDaysForEditWork) {
    url = `/admin/shift/${shiftId}/work/${workId}/bypass`
  }

  const response = await api.patch(url, {
    status,
    clocked_in_at: clockedInAt,
    clocked_out_at: clockedOutAt,
    left_early: leftEarly,
  })

  return response.data
}
